import script from "./AppNavDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppNavDrawer.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer});
